<template>
  <div class="content article">
    <div class="article-body">
      <h1 class="article-title">To Do</h1>
      <div class="card">
        <div class="card-content">
          <p>
            After I find I job, I plan to continue working on this project. Below is a list of things I'd like to do. In no particular order.
            If you find something interesting, have questions, or suggestions, I can be reached at <a href="mailto:hello@timganter.io">hello@timganter.io</a>.
          </p>

          <ul>
            <li>Investigate features that can take advantage of geolocation on devices. For example, "collisions near me".</li>
            <li>Investigate other ways of measuring / ranking. Per captia? Per square mile? Percentage of collisions? Etc.</li>
            <li>Toggle between economic and comprehensive costs.</li>
            <li>Ability to draw a custom boundary</li>
            <li>Investigate open sourcing the project</li>
            <li>Think about other data sets that I could combine this with</li>
            <li>Investigate predictive analysis. Can I use the data to predict conditions of a car crash? Severity of a car crash? TensorFlow!?!</li>
            <li>Add location pins to map on neighborhood view. Click on pin and see all collisions for that location.</li>
            <li>Make collisions by location. Enter locations and then view collisions for those locations.</li>
            <li>Investigate ways to analyze locations. Ex. location with most pedestrians hit, most injuries, etc. </li>
            <li>
              Make additional views that could reveal interesting trends. For example...Day of the week with most collisions. 
              Month with the most collisions, etc.
            </li>
            <li>Look into server-side rendering.</li>
            <li>Look into service workers &amp; Progressive Web Apps.</li>
            <li>Light refactoring for front end code.</li>
            <li>Light refactoring for back end code.</li>
            <li>Look at areas to improve performance. Especially with map rendering lots of data.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'toDo'
}
</script>

<style lang="scss">
@import "./src/sass/views/article";
@import "./src/sass/card";
</style>



// WEBPACK FOOTER //
// ToDo.vue?3019751a